import BellBing from '@betfan/icons/linear/Notifications/BellBing.svg?react';
import cn from 'classnames';
import React, { PropsWithChildren } from 'react';
import './DSInputStyles.scss';

export type DSHelpTextColor = 'green' | 'theme' | 'error';

interface DSHelpTextProps extends Pick<React.HTMLAttributes<HTMLDivElement>, 'className'> {
	color: DSHelpTextColor;
	disabled?: boolean;
	cyErrorRef?: string;
}

export const DSHelpText = (props: PropsWithChildren<DSHelpTextProps>) => {
	const classes = () =>
		cn(
			{
				'text-gray-200': props.color === 'green',
				'text-gray-700 dark:text-gray-300': props.color === 'theme',
				'text-error-500': props.color === 'error',
			},
			{
				'opacity-30': props.disabled && props.color !== 'error',
			},
			'text-paragraph-sm flex items-center',
			props.className,
		);

	return (
		<div className={classes()}>
			<div>
				<BellBing className="w-4 h-4" />
			</div>
			<div data-cy={props.cyErrorRef} className="ml-2">
				{props.children}
			</div>
		</div>
	);
};
